class OrbitalLines extends HTMLElement {
  constructor() {
    super();
    this.svg = this.querySelector("svg");
    if (!this.svg) {
      return;
    }
    this.intersectionObserver = new IntersectionObserver(
      this.handleIntersection.bind(this),
      { rootMargin: "0px", threshold: 0 }
    );
    this.intersectionObserver.observe(this);

    this.classList.remove("hidden");
  }

  handleIntersection(entries, observer) {
    if (entries[0].isIntersecting) {
      this.svg.classList.add("animate");
      this.svg.unpauseAnimations();
    } else {
      this.svg.classList.remove("animate");
      this.svg.pauseAnimations();
    }
  }
}

customElements.define("orbital-lines", OrbitalLines);
